export default __webpack_public_path__ + "static/media/hamburger-menu.f34a8335.svg";